/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.permissionsModule', ['angular-bind-html-compile', 'focus-if', 'bulbApp.authModule',
  'bulbApp.autoSaveModule', 'bulbApp.configModule', 'bulbApp.pageModule', 'bulbApp.translateModule',
  'bulbApp.unitModule'])

.constant('PERMISSIONS', {
  COPY: {
    COPY_TIMEOUT: 7000 // 7 seconds
  }
})

// Add the constants to the root scope:
.run(['$rootScope', 'PERMISSIONS', function($rootScope, PERMISSIONS) {
  $rootScope.PERMISSIONS = PERMISSIONS;
}]);
